import * as Sentry from '@sentry/react'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { queryClient } from '@/queries'

import { useSession } from './session'
import { clearAuthTokens } from './token-storage'
import { useUser } from './user'

let pendingLogout: Promise<void> | null = null

export function useLogout() {
  const { clearSession } = useSession()
  const { clearUser } = useUser()
  const navigate = useNavigate()

  return useCallback(() => {
    if (pendingLogout) return pendingLogout

    pendingLogout = (async () => {
      clearAuthTokens()
      await navigate('/login', { replace: true })
      clearUser()
      clearSession()
      await queryClient.cancelQueries()
      queryClient.clear()
      Sentry.setUser(null)
    })().finally(() => {
      pendingLogout = null
    })

    return pendingLogout
  }, [clearUser, clearSession, navigate])
}
